// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__216hE","left":"InfoRow_left__3L_pt"};